import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled, { css } from "styled-components";
import { IconController } from "../../Scripts/ImgController";
import Ripples from "react-ripples";

const Wrapper = styled.div`
  width: 100%;
  ${(props) =>
    props.type === "mkaraoke"
      ? css`
          :hover {
            background: linear-gradient(
              270deg,
              rgba(255, 255, 255, 0.45) 0%,
              rgba(255, 255, 255, 0) 100%
            );
          }
        `
      : css`
          :hover {
            background: linear-gradient(
              270deg,
              rgba(0, 97, 255, 0.45) 0%,
              rgba(0, 97, 255, 0) 100%
            );
          }
        `}
`;

const SidebarMenu = ({
  icon,
  title,
  where,
  setLogoutConfirmation,
  sidebarExpanded,
  type = "music",
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Extract context from current pathname (e.g., "music" or "karaoke")
  const context = location.pathname.split("/")[1];

  // Determine active state
  const isActive =
    where === ""
      ? location.pathname === `/${context}` ||
        location.pathname === `/${context}/`
      : location.pathname === `/${context}/${where}`;

  const activeClass =
    type === "mkaraoke"
      ? isActive && "sidebar-active-karaoke"
      : isActive && "sidebar-active";

  const clickHandler = () => {
    if (where === "logout") {
      setLogoutConfirmation(true);
    } else {
      if (where.startsWith("/")) {
        navigate(where);
      } else {
        navigate(`/${context}/${where}`);
      }
    }
  };

  return (
    <Ripples color="#ffffff40" during={600} className="w-full">
      <Wrapper onClick={clickHandler} type={type}>
        <div
          className={`w-full py-4 px-8 text-white flex flex-row items-center cursor-pointer ${
            activeClass || ""
          }`}
        >
          <IconController src={icon} alt="" className="w-5 h-5" />
          <h5
            className={`title text-sm origin-left duration-200 ${
              sidebarExpanded ? "pl-3" : "hidden"
            }`}
          >
            {title}
          </h5>
        </div>
      </Wrapper>
    </Ripples>
  );
};

export default SidebarMenu;
